// 自动生成的word模板数据
const words = [
  {
    "id": "634409c1612612f96cb78bf6",
    "page": "word-1.html",
    "title": "高端创意简历word模板"
  },
  {
    "id": "63469a8701900919793c57c2",
    "page": "word-2.html",
    "title": "高端创意简历word模板"
  },
  {
    "id": "63469bec01900919793c5808",
    "page": "word-3.html",
    "title": "高端简洁word简历模板"
  },
  {
    "id": "63469d3901900919793c584d",
    "page": "word-4.html",
    "title": "高端创意中国风美术word简历模板"
  },
  {
    "id": "6346ad1c554cfa7c2597202a",
    "page": "word-5.html",
    "title": "单页简洁表格word简历模板"
  },
  {
    "id": "6346aded554cfa7c25972073",
    "page": "word-6.html",
    "title": "表格风极简word简历模板"
  },
  {
    "id": "6347776e554cfa7c25972e70",
    "page": "word-7.html",
    "title": "简洁易修改的表格word简历模板"
  },
  {
    "id": "63477949554cfa7c25972f10",
    "page": "word-8.html",
    "title": "单页表格类型极简风word简历模板"
  },
  {
    "id": "63477a02554cfa7c25972f2a",
    "page": "word-9.html",
    "title": "表格极简风格word简历模板"
  },
  {
    "id": "63477be7554cfa7c25972fb3",
    "page": "word-10.html",
    "title": "单页活泼风格word简历模板"
  },
  {
    "id": "63477f9a554cfa7c259731b4",
    "page": "word-11.html",
    "title": "单页活泼创意word简历模板"
  },
  {
    "id": "6349073f044b853dd1b12875",
    "page": "word-12.html",
    "title": "单页活泼护士word简历模板"
  },
  {
    "id": "63492352a6d8d129f58fb3b2",
    "page": "word-13.html",
    "title": "单页活泼运营专员word简历模板"
  },
  {
    "id": "634bf07ea6d8d129f58fd823",
    "page": "word-14.html",
    "title": "单页二简约表格word简历模板"
  },
  {
    "id": "634bf0fea6d8d129f58fd834",
    "page": "word-15.html",
    "title": "单页简约创意彩色word简历模板"
  },
  {
    "id": "634bf1b5a6d8d129f58fd848",
    "page": "word-16.html",
    "title": "单页常规大众简约word简历模板"
  },
  {
    "id": "634bf258a6d8d129f58fd897",
    "page": "word-17.html",
    "title": "单页简约黑白word简历模板"
  },
  {
    "id": "634bf2c0a6d8d129f58fd8a5",
    "page": "word-18.html",
    "title": "单页简约彩色word简历封面"
  },
  {
    "id": "63525be27594a9a5c6077c6c",
    "page": "word-19.html",
    "title": "文艺青年简约单页word简历模板"
  },
  {
    "id": "635748257594a9a5c607bb2f",
    "page": "word-20.html",
    "title": "稳重单页简约word建立模板"
  },
  {
    "id": "635749357594a9a5c607bb6b",
    "page": "word-21.html",
    "title": "单页稳重简约word简历模板"
  },
  {
    "id": "63577e110d28f6f5a99e1ec0",
    "page": "word-22.html",
    "title": "单页简约word简历模板"
  },
  {
    "id": "63577e8a0d28f6f5a99e1ed1",
    "page": "word-23.html",
    "title": "单页经典简约word简历模板"
  },
  {
    "id": "635780d00d28f6f5a99e1ee2",
    "page": "word-24.html",
    "title": "单页简约word简历封面模板"
  },
  {
    "id": "635781f30d28f6f5a99e1eed",
    "page": "word-25.html",
    "title": "单页简约word简历封面模板"
  },
  {
    "id": "6357825f0d28f6f5a99e1ef5",
    "page": "word-26.html",
    "title": "单页彩色word简历封面模板"
  },
  {
    "id": "6357850a0d28f6f5a99e1fd3",
    "page": "word-27.html",
    "title": "简约单页word简历模板"
  },
  {
    "id": "6357857f0d28f6f5a99e1fdb",
    "page": "word-28.html",
    "title": "简约单页word简历模板"
  },
  {
    "id": "6357862a0d28f6f5a99e1fe6",
    "page": "word-29.html",
    "title": "单页简约word简历模板"
  },
  {
    "id": "6357870c0d28f6f5a99e1ff1",
    "page": "word-30.html",
    "title": "多页唯美创意风格word简历模板"
  },
  {
    "id": "63579c8e5c66399fa5a29fe8",
    "page": "word-31.html",
    "title": "单页文艺简约word简历模板"
  },
  {
    "id": "63579d8c5c66399fa5a2a027",
    "page": "word-32.html",
    "title": "单页文艺创意花边word简历模板"
  },
  {
    "id": "63579e395c66399fa5a2a034",
    "page": "word-33.html",
    "title": "单页文艺简约word简历模板"
  },
  {
    "id": "63579efa5c66399fa5a2a0ac",
    "page": "word-34.html",
    "title": "简约单页文艺word简历模板"
  },
  {
    "id": "63579f6f5c66399fa5a2a0e7",
    "page": "word-35.html",
    "title": "艺术简约文艺word简历模板"
  },
  {
    "id": "6357a0bf5c66399fa5a2a0ef",
    "page": "word-36.html",
    "title": "单页创意文艺word简历模板"
  },
  {
    "id": "6357a1415c66399fa5a2a0f7",
    "page": "word-37.html",
    "title": "单页护士简约word简历模板"
  },
  {
    "id": "6357cc08b58e0ea2fbced5fd",
    "page": "word-38.html",
    "title": "简约彩色单页word简历模板"
  },
  {
    "id": "6357ccc6b58e0ea2fbced605",
    "page": "word-39.html",
    "title": "单页简约护士护理蓝色word简历模板"
  },
  {
    "id": "6357cd4ab58e0ea2fbced610",
    "page": "word-40.html",
    "title": "单页创意word简历模板"
  },
  {
    "id": "6357cde7b58e0ea2fbced618",
    "page": "word-41.html",
    "title": "单页创意新媒体word简历模板"
  },
  {
    "id": "6357ce73b58e0ea2fbced623",
    "page": "word-42.html",
    "title": "单页简约行政管理word简历模板 "
  },
  {
    "id": "6357ceefb58e0ea2fbced644",
    "page": "word-43.html",
    "title": "单页金融简约word简历模板"
  },
  {
    "id": "6357d0ecb58e0ea2fbced752",
    "page": "word-44.html",
    "title": "单页简约市场营销word简历模板"
  },
  {
    "id": "6357d188b58e0ea2fbced75d",
    "page": "word-45.html",
    "title": "单页Java工程师word简历模板"
  },
  {
    "id": "6357d226b58e0ea2fbced79b",
    "page": "word-46.html",
    "title": "单页极简风格word简历模板"
  },
  {
    "id": "635b7cc0b58e0ea2fbcf19b0",
    "page": "word-47.html",
    "title": "单页简约word简历模板"
  },
  {
    "id": "635b7e57b58e0ea2fbcf19ea",
    "page": "word-48.html",
    "title": "单页文艺小清新创新word简历模板"
  },
  {
    "id": "635b7ffeb58e0ea2fbcf19ff",
    "page": "word-49.html",
    "title": "单页国风创意word简历模板"
  },
  {
    "id": "635b8065b58e0ea2fbcf1a07",
    "page": "word-50.html",
    "title": "单页经典word简历模板"
  },
  {
    "id": "635e710ba84083e3550e901c",
    "page": "word-51.html",
    "title": "个人应届生创意求职word简历模板"
  },
  {
    "id": "635fc7acb58e0ea2fbcf6c67",
    "page": "word-52.html",
    "title": "个性创意多页word简历模板"
  },
  {
    "id": "635fc954b58e0ea2fbcf6ca2",
    "page": "word-53.html",
    "title": "个性创意单页word简历模板"
  },
  {
    "id": "635fca1cb58e0ea2fbcf6ce4",
    "page": "word-54.html",
    "title": "经典毕业生word简历模板"
  },
  {
    "id": "6360ddd7b58e0ea2fbcf81b7",
    "page": "word-55.html",
    "title": "单页蓝色系简约word简历模板"
  },
  {
    "id": "6360de5cb58e0ea2fbcf81f2",
    "page": "word-56.html",
    "title": "单页经典简约word简历模板"
  },
  {
    "id": "6360dec3b58e0ea2fbcf81fa",
    "page": "word-57.html",
    "title": "单页经典简约word简历模板"
  },
  {
    "id": "6360df34b58e0ea2fbcf8205",
    "page": "word-58.html",
    "title": "单页经典清新风格word简历模板"
  },
  {
    "id": "636116dab58e0ea2fbcf8619",
    "page": "word-59.html",
    "title": "单页经典英文word简历模板"
  },
  {
    "id": "63611792b58e0ea2fbcf8651",
    "page": "word-60.html",
    "title": "单页创意英文word简历模板"
  },
  {
    "id": "636117fbb58e0ea2fbcf8659",
    "page": "word-61.html",
    "title": "单页三色创意英文word简历模板"
  },
  {
    "id": "63637ea6b58e0ea2fbcfcc5a",
    "page": "word-62.html",
    "title": "单页互联网电商简洁word简历模板"
  },
  {
    "id": "63637f27b58e0ea2fbcfcca4",
    "page": "word-63.html",
    "title": "活泼单页会计word简历模板"
  },
  {
    "id": "63637fa0b58e0ea2fbcfccc0",
    "page": "word-64.html",
    "title": "单页前端工程师活泼word简历模板"
  },
  {
    "id": "63638044b58e0ea2fbcfcd02",
    "page": "word-65.html",
    "title": "单页互联网活泼word简历模板"
  },
  {
    "id": "636380b8b58e0ea2fbcfcd67",
    "page": "word-66.html",
    "title": "单页互联网word简历模板"
  },
  {
    "id": "63638136b58e0ea2fbcfcdff",
    "page": "word-67.html",
    "title": "单页活泼封面word模板"
  },
  {
    "id": "636381aeb58e0ea2fbcfce4b",
    "page": "word-68.html",
    "title": "单页创意互联网word简历模板"
  },
  {
    "id": "63638287b58e0ea2fbcfced1",
    "page": "word-69.html",
    "title": "单页创意活泼word简历模板"
  },
  {
    "id": "636382f5b58e0ea2fbcfceef",
    "page": "word-70.html",
    "title": "单页彩色封面word模板"
  },
  {
    "id": "63638382b58e0ea2fbcfcf47",
    "page": "word-71.html",
    "title": "单页创意互联网word简历模板"
  },
  {
    "id": "6368c1f9b58e0ea2fbd037cc",
    "page": "word-72.html",
    "title": "单页简洁表格word简历模板"
  },
  {
    "id": "63737823c37b765e454237fb",
    "page": "word-73.html",
    "title": "财务会计简约风word简历模板"
  },
  {
    "id": "637378afc37b765e45423806",
    "page": "word-74.html",
    "title": "创意彩色风格word简历模板"
  },
  {
    "id": "63737921c37b765e4542380e",
    "page": "word-75.html",
    "title": "常规简约红色风格word简历模板"
  },
  {
    "id": "63737991c37b765e45423816",
    "page": "word-76.html",
    "title": "常规营销word简历模板"
  },
  {
    "id": "63737a84c37b765e4542385d",
    "page": "word-77.html",
    "title": "市场专员创意word简历模板"
  },
  {
    "id": "63737af7c37b765e4542388d",
    "page": "word-78.html",
    "title": "创意艺术彩色风格word简历模板"
  },
  {
    "id": "63737b60c37b765e454238d6",
    "page": "word-79.html",
    "title": "创意风格市场专员word简历模板"
  },
  {
    "id": "63737c05c37b765e4542394c",
    "page": "word-80.html",
    "title": "创意几何风格word简历模板"
  },
  {
    "id": "63737f63c37b765e4542397d",
    "page": "word-81.html",
    "title": "创意风格UI设计师word简历模板"
  },
  {
    "id": "63737fc4c37b765e45423988",
    "page": "word-82.html",
    "title": "数据分析简约word简历模板"
  },
  {
    "id": "63738037c37b765e45423990",
    "page": "word-83.html",
    "title": "创意风格IOS工程师word简历模板"
  },
  {
    "id": "63738094c37b765e45423998",
    "page": "word-84.html",
    "title": "常规标准简约风格word简历模板"
  },
  {
    "id": "637380f8c37b765e454239a0",
    "page": "word-85.html",
    "title": "创意互联网个性word简历模板"
  },
  {
    "id": "637381c4c37b765e454239b8",
    "page": "word-86.html",
    "title": "暗色创意两页word简历模板"
  },
  {
    "id": "63738245c37b765e454239d0",
    "page": "word-87.html",
    "title": "创意暗色几何风格word简历模板"
  },
  {
    "id": "637382b3c37b765e454239d8",
    "page": "word-88.html",
    "title": "创意简约风格word简历模板"
  },
  {
    "id": "6384589c91d908a9a1b997ea",
    "page": "word-89.html",
    "title": "活泼单页创意word简历模板"
  },
  {
    "id": "638459b591d908a9a1b99806",
    "page": "word-90.html",
    "title": "创意单页彩色word简历模板"
  },
  {
    "id": "63845f3691d908a9a1b99949",
    "page": "word-91.html",
    "title": "单页经典通用word简历模板"
  },
  {
    "id": "6384600591d908a9a1b99977",
    "page": "word-92.html",
    "title": "创意市场营销word见咯模板"
  },
  {
    "id": "6384609291d908a9a1b999d3",
    "page": "word-93.html",
    "title": "单页创意word简历模板"
  },
  {
    "id": "638460fc91d908a9a1b999e5",
    "page": "word-94.html",
    "title": "单页创意word简历封面模板"
  },
  {
    "id": "6384616591d908a9a1b999f5",
    "page": "word-95.html",
    "title": "创意扁平风几何word简历封面模板"
  },
  {
    "id": "638461cb91d908a9a1b99a23",
    "page": "word-96.html",
    "title": "清新活泼图标word简历封面模板"
  },
  {
    "id": "6384623091d908a9a1b99a3d",
    "page": "word-97.html",
    "title": "彩色小清新word简历封面模板"
  },
  {
    "id": "6384628a91d908a9a1b99a49",
    "page": "word-98.html",
    "title": "彩色文艺word简历封面模板"
  },
  {
    "id": "638462dd91d908a9a1b99ad1",
    "page": "word-99.html",
    "title": "创意活泼word简历封面模板"
  },
  {
    "id": "640085c57eb648f45a015e1c",
    "page": "word-100.html",
    "title": "毕业生创意单页word简历模板"
  },
  {
    "id": "64340dacc3585dc5f8d036ab",
    "page": "word-101.html",
    "title": "单页英文传统word简历模板"
  },
  {
    "id": "64340e4ec3585dc5f8d037cc",
    "page": "word-102.html",
    "title": "单页英文传统word简历模板"
  },
  {
    "id": "64340ee1c3585dc5f8d0386e",
    "page": "word-103.html",
    "title": "单页英文传统word简历模板"
  },
  {
    "id": "6434105bc3585dc5f8d03c5e",
    "page": "word-104.html",
    "title": "表格单页公务员word简历模板"
  },
  {
    "id": "643c908cc3585dc5f8d37fe5",
    "page": "word-105.html",
    "title": "创意多页市场Word简历模板"
  },
  {
    "id": "6454f91f6cb7b03b2b0dcce3",
    "page": "word-106.html",
    "title": "艺术类word简历模板含封面"
  },
  {
    "id": "646e0c156a47c256f6d8afb0",
    "page": "word-107.html",
    "title": "创意风格word简历封面模板"
  },
  {
    "id": "6474a48dd8dec5dbcb3cda68",
    "page": "word-108.html",
    "title": "经典单页左右布局word简历模板"
  },
  {
    "id": "6475f322d8dec5dbcb3d1ab0",
    "page": "word-109.html",
    "title": "简约表格经典word简历模板"
  },
  {
    "id": "647f2cf9021391e3467e3764",
    "page": "word-110.html",
    "title": "清新风单页简历封面word模板"
  },
  {
    "id": "647f2da7021391e3467e3826",
    "page": "word-111.html",
    "title": "创意背景单页word简历模板"
  },
  {
    "id": "649982fa4580586ac4c35d84",
    "page": "word-112.html",
    "title": "三页市场营销专员创意风word简历模板"
  },
  {
    "id": "64c0f7d1c57a351ab724ae88",
    "page": "word-113.html",
    "title": "单页三色常规word简历模板"
  },
  {
    "id": "64c0f899c57a351ab724ae93",
    "page": "word-114.html",
    "title": "单页创意word简历模板"
  },
  {
    "id": "64c0f974c57a351ab724aec1",
    "page": "word-115.html",
    "title": "创意风格word简历模板"
  },
  {
    "id": "64f1d081f376b2d0e1a0fbef",
    "page": "word-116.html",
    "title": "封面+介绍性+简历三页word简历模板"
  },
  {
    "id": "64f1d182f376b2d0e1a0fc7c",
    "page": "word-117.html",
    "title": "创意word简历模板封面"
  },
  {
    "id": "64f1d2acf376b2d0e1a0fcbc",
    "page": "word-118.html",
    "title": "创意红word简历模板封建"
  },
  {
    "id": "64f1d33ef376b2d0e1a0fcde",
    "page": "word-119.html",
    "title": "简约风word简历模板封面"
  },
  {
    "id": "64f1d40cf376b2d0e1a0fce6",
    "page": "word-120.html",
    "title": "几何风格创意word简历模板封面"
  },
  {
    "id": "64f1d499f376b2d0e1a0fd20",
    "page": "word-121.html",
    "title": "创意风格word简历模板封面"
  },
  {
    "id": "655ea04646a8e8f0ebabf968",
    "page": "word-122.html",
    "title": "创意单页产品经理word简历模板"
  },
  {
    "id": "655ea15146a8e8f0ebabf9f1",
    "page": "word-123.html",
    "title": "创意单页产品运营word简历模板"
  },
  {
    "id": "659d2c5f46a8e8f0ebb4f824",
    "page": "word-124.html",
    "title": "单页创意彩色word简历模板"
  },
  {
    "id": "659d2d3746a8e8f0ebb4f8e4",
    "page": "word-125.html",
    "title": "单页创意彩色word简历模板"
  },
  {
    "id": "6674201beeb2c7c65e62c5d6",
    "page": "word-126.html",
    "title": "单页单色简洁Word简历模板"
  },
  {
    "id": "667420cdeeb2c7c65e62c684",
    "page": "word-127.html",
    "title": "单色单页创意word简历模板"
  },
  {
    "id": "66b6e61627d88b4a93942516",
    "page": "word-128.html",
    "title": "表格简洁word简历模板"
  },
  {
    "id": "66b6e69727d88b4a93942530",
    "page": "word-129.html",
    "title": "表格word简历模版"
  },
  {
    "id": "66b6e79b27d88b4a939425e9",
    "page": "word-130.html",
    "title": "双页简历封面模板"
  },
  {
    "id": "66b6e82627d88b4a9394263f",
    "page": "word-131.html",
    "title": "创意单页word简历封面模板"
  },
  {
    "id": "66b6e90f27d88b4a939427e7",
    "page": "word-132.html",
    "title": "清爽型单页word简历模版"
  },
  {
    "id": "66c48f48666eee059443e80c",
    "page": "word-133.html",
    "title": "单页彩色word简历封面"
  }
];

export default words;